import React, { useEffect, useRef, useState } from "react";

const About = () => {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.3 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    // ✅ Corrected Image Path (Django serves static files from `/static/`)
    const imagePath = "/static/img_portfolio.JPG";

    return (
        <section
            id="about"
            ref={sectionRef}
            className={`py-16 bg-gray-100 dark:bg-gray-900 transition-all ${isVisible ? "animate-fadeIn" : "opacity-0"
                }`}
        >
            <div className="container mx-auto px-6 md:px-12 lg:px-20 text-center">
                <h2 className="text-4xl font-extrabold text-gray-800 dark:text-white mb-6">
                    About Me
                </h2>

                <p className="text-lg text-gray-600 dark:text-gray-300 max-w-3xl mx-auto leading-relaxed">
                    I&apos;m a{" "}
                    <span className="font-semibold text-gray-800 dark:text-white">
                        Software Engineer
                    </span>{" "}
                    with expertise in{" "}
                    <span className="font-semibold text-blue-500">
                        Full-Stack Development, AI, IoT, and Cloud Computing
                    </span>
                    . I build{" "}
                    <span className="font-semibold text-green-500">
                        scalable, high-performance applications
                    </span>{" "}
                    and specialize in{" "}
                    <span className="font-semibold text-yellow-500">
                        solving complex problems
                    </span>{" "}
                    with <strong>clean and efficient code</strong>.
                </p>

                {/* ✅ Updated Image Path */}
                <div className="mt-8 flex justify-center">
                    <img
                        src={imagePath}
                        alt="Your Name"
                        className="rounded-full w-40 h-40 md:w-48 md:h-48 lg:w-56 lg:h-56 border-4 border-blue-500 object-cover shadow-lg"
                    />
                </div>

                <div className="mt-6 flex flex-wrap justify-center gap-4">
                    <span className="px-5 py-2 bg-blue-500 text-white rounded-lg text-lg font-semibold shadow-md">
                        React.js
                    </span>
                    <span className="px-5 py-2 bg-green-500 text-white rounded-lg text-lg font-semibold shadow-md">
                        Django
                    </span>
                    <span className="px-5 py-2 bg-yellow-500 text-white rounded-lg text-lg font-semibold shadow-md">
                        JavaScript
                    </span>
                    <span className="px-5 py-2 bg-gray-700 text-white rounded-lg text-lg font-semibold shadow-md">
                        Node.js
                    </span>
                    <span className="px-5 py-2 bg-purple-500 text-white rounded-lg text-lg font-semibold shadow-md">
                        Machine Learning
                    </span>
                    <span className="px-5 py-2 bg-pink-500 text-white rounded-lg text-lg font-semibold shadow-md">
                        AI
                    </span>
                    <span className="px-5 py-2 bg-cyan-500 text-white rounded-lg text-lg font-semibold shadow-md">
                        IoT
                    </span>
                    <span className="px-5 py-2 bg-indigo-500 text-white rounded-lg text-lg font-semibold shadow-md">
                        Cloud Computing
                    </span>
                    <span className="px-5 py-2 bg-red-500 text-white rounded-lg text-lg font-semibold shadow-md">
                        DevOps
                    </span>
                </div>
            </div>
        </section>
    );
};

export default About;
